<!-- /* * Confidential and Proprietary. * Do not distribute without 1-800-Flowers.com, Inc. consent. *
Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved. */ -->

<svelte:head>
	<script
		src="https://code.jquery.com/jquery-3.7.1.slim.min.js"
		integrity="sha256-kmHvs0B+OpCW5GVHUNjv9rOmY0IvSIRcf7zGUDTDQM8="
		crossorigin="anonymous"
	></script>
</svelte:head>
<slot></slot>

<script>
	import { tealium } from '$lib/utilities/analytics';
	import { initDatadog } from '$lib/utilities/datadog/initDDClient';
	import { onMount } from 'svelte';
	onMount(() => {
		initDatadog();
		tealium.initialize();
	});
</script>
